export default __webpack_public_path__ + "static/media/Tunic of Intricate Spite.67621240.jpg";